import React, { useState } from "react";
import { ListCostOfGoods } from "../../../redux/reports/reportsType";

import { TableLoader } from "../../commons";
import CostOfGoodsStatementTableData from "./CostOfGoodsStatementTableData";
import { tableHeader } from "../DetailedBalanceSheet/BalanceSheetTable";
import { getData } from "./common";
import { currencySignAndNegativeValueAdjust } from "../../../utils/commonFunctions";

type AppProps = {
  data: ListCostOfGoods[];

  total: number;
  fetching: boolean;
  subHeader: string;
  currencySign: string | undefined;
  inDirectData?: ListCostOfGoods[];
  totalDirectExpense?: number | undefined;
  closeingStock?: number | undefined;
  hanldeOpenAll?: (arr: ListCostOfGoods[], data: string) => void
  hanldeCloseAll?: (arr: ListCostOfGoods[], data: string) => void;
  startDate: string;
  endDate: string;
  finalRedirectLink: { pathname: string };
  isLedgerStatementPresent?:boolean;
};

const CostOfGoodsTable = ({
  data,
  total,
  fetching,
  subHeader,
  currencySign,
  inDirectData,
  totalDirectExpense,
  startDate,
  endDate,
  finalRedirectLink,
  isLedgerStatementPresent

}: AppProps) => {
  const [isAllOpen, setIsAllOpen] = useState<boolean>(false);



  const renderBody = () => {
    let finalData = getData(data)?.map((singleData: any, index: number) => {
      return (
        <CostOfGoodsStatementTableData
          singleData={singleData}
          count={1}
          index={index + 1}
          currencySign={currencySign}
          inDirectData={inDirectData}
          isAllOpen={isAllOpen}
          finalRedirectLink={finalRedirectLink}
          startDate={startDate}
          endDate={endDate}
          isLedgerStatementPresent={isLedgerStatementPresent}
        />
      );
    });
    return finalData;
  };

  const renderFooter = (str?: string) => {
    let finalData = tableHeader?.map((thead: any) => {
      if (thead?.value === "ledger_name") {
        return <td>
          <p>{subHeader === "Income" || subHeader === "Incomes" ? "TOTAL INCOME" : subHeader === "Expense" ? "TOTAL EXPENSE" : subHeader === "cost_of_goods_sold" && !str ? "GROSS PROFIT" : subHeader === "cost_of_goods_sold" && str ? str : ""}</p>
        </td>
      }
      if (thead?.value === "closing_amount") {
        return (
          <td>
            <p className={"reports-total"}>
              {str ? currencySignAndNegativeValueAdjust(currencySign,totalDirectExpense?totalDirectExpense?.toFixed(2)?.toString():""): +total ? currencySignAndNegativeValueAdjust(currencySign,total?total?.toFixed(2)?.toString():"") : 0}
            </p>
          </td>
        );
      }
    });
    return finalData;
  };

  const renderHeader = () => {
    return (
      <th
        style={{
          backgroundColor: "#e8ecf0",
          border: "none",
          borderRadius: "0px",
          color: "#6e7491",
          fontWeight: 600,
          fontSize: "14px",
          width: "75%",
        }}
      >
        ACCOUNT NAME
      </th>
    );
  };
  // use for future 
  // let checkData = data?.filter(obj => obj?.data && obj?.data?.length > 0)

  return (
    <>
      {fetching ? (
        <TableLoader Rows={10} ColumnPerRow={8} />
      ) : (
        <div className={`grouping ${subHeader === "Income" ? "mt-2" : "mt-5"}`} >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ fontSize: "20px" }}>{subHeader === "Income" || subHeader === "Incomes" ? "Income" : subHeader === "cost_of_goods_sold" ? "Cost of Goods Sold (COGS)" : subHeader === "Expense" ? "Expense" : ""} </h3>
            <div style={{ display: "flex", cursor: "pointer", color: "#dd4433", width: "20%", justifyContent: "end", gap: "5%", fontWeight: "600" }}>
            </div>
          </div>
          <table className="table table-bordered">

            <thead>
              {renderHeader()}
              <th
                style={{
                  backgroundColor: "#e8ecf0",
                  borderLeft: "solid 1px #bfcbe1",
                  borderRadius: "0px",
                }}
              >
                AMOUNT
              </th>
            </thead>
            {renderBody()}

            <tfoot>

              {totalDirectExpense != undefined ? <tr>{renderFooter("TOTAL COST OF GOODS SOLD (COGS)")}</tr> : ""}

              {renderFooter()}
            </tfoot>
          </table>
        </div>
      )}
    </>
  );
};

export default CostOfGoodsTable;
